import React from 'react'
import { searchAddress } from '../../store/address/address.actions'
import { TAG_SUGGEST } from '../analytics/analytics.tagids.constants'
import { setSearchTerms } from '../../store/search/searchSlice'
import { removeHtmlEmTags } from '../../utils/string'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import { useAction } from '../utils/react-redux'
import SuggestContent from './SuggestContent'
import { SUGGEST_FROM_VALUES } from './suggest.constants'
import { useDispatch } from 'react-redux'

const AddressSuggestContent = () => {
  const dispatch = useDispatch()
  const execSearchAddress = useAction(searchAddress)
  const configureAndSendTag = useConfigureAndSendTag()

  const onClick = suggest => {
    const { labels, address, type, subtype, from } = suggest
    const label = removeHtmlEmTags(address || labels.join(' '))
    dispatch(setSearchTerms(label))

    if (from === SUGGEST_FROM_VALUES.favorites) {
      configureAndSendTag({
        type: TAG_SUGGEST,
        tagInfo: { type, subtype, from }
      })
    }

    execSearchAddress({ terms: label })
  }

  return <SuggestContent onClick={onClick} />
}

export default AddressSuggestContent
